<template>
    <div id="wrapper" :key="valuekey">
        <div class="col-md-12">
            <div class="card-box">
                <div class="form-row">
                    <div class="col-md-11">
                        <h4 class="page-title">{{$t('string.msg.request.founded.trucker.title')}}</h4>
                    </div>
                    <div class="col-md-1" v-if="items">
                        <h4 class="text-center">{{$t('str.total')}}</h4>
                        <h4 class="text-center" style="color:grey">{{items.length}}</h4>
                    </div>
                </div>
              <div class="table-responsive">
                    <table class="table table-centered table-hover mb-0" id="datatable">
                        <thead>
                            <tr>
                                <th class="border-top-0">{{$t('string.msg.company.label.name')}}</th>
                                <th class="border-top-0">{{$t('string.msg.company.label.main.email')}}</th>
                                <th class="border-top-0">{{$t('string.msg.company.label.primaryPhone')}}</th>
                                <th class="border-top-0">{{$t('string.msg.company.label.truck')}}</th>
                                 <th class="border-top-0">{{$t('string.msg.company.label.plate')}}</th>
                            </tr>
                        </thead>
                        <tbody v-bind:key="item._id" v-for="item in items" class="cursor-pointer">
                            <tr v-if="item && item.truckDriver">
                                <td>
                                    <span v-if="item.truckDriver.firstName"> {{toUpperCase(item.truckDriver.firstName + ' ')}} </span>
                                    <span v-if="item.truckDriver.lastName"> {{toUpperCase(item.truckDriver.lastName)}} </span>
                                </td>
                                <td>
                                    <span v-if="item.truckDriver.email">
                                        {{(item.truckDriver.email)}} 
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.truckDriver.primaryPhone">
                                        {{(item.truckDriver.primaryPhone)}}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.manufacturer && item.manufacturer.name">{{ toUpperCase(item.manufacturer.name) + ' - '}}</span>
                                    <span v-if="item.manufacturer && item.manufacturer.name">{{item.model && item.model.name ? toUpperCase(item.model.name) + ' - ' : '' + ' - '}}</span>
                                    <span v-if="item.manufacturer && item.manufacturer.name">{{item.year}}</span>
                                </td>
                                <td>
                                    <span v-if="item.plate">
                                        {{ toUpperCase(item.plate)}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Controller from './CrtWithoutCertifie';
export default {
  name: 'WithoutCertifie',
  props: ["valuekey"],
  watch:{
    'valuekey'(){}
  },
  components: {
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        items: [],
      }
  },
  methods: Controller.methods,
  created() {
    
  },
  mounted(){
      Controller.init(this);

  }
}
</script>